import { set } from 'date-fns';

const pruneTimeFromDate = date => set(new Date(date), { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });

export default pruneTimeFromDate;
